import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getProviderName, gymAddress } from "../../../../util/utils";
import { brand } from "../../../../config/brands";
import { isUndefined } from "lodash";
import Image from "../providers/Image";
import Briefcase from "../../../assets/images/briefcase.svg";
import Location from "../../../assets/images/location.svg";

const ProviderCard = ({ evaluation, condition, provider }) => {
  let navigate = useNavigate();

  const getProviderProfileUrl = (provider) => {
    if (provider?.isPractice) {
      return `/${provider?.speciality?.toLowerCase()}/practice/${
        provider.npiId
      }/${provider?.practiceLocationGroupId}`;
    }
    if (provider?.npiId) {
      return `/${provider?.speciality?.toLowerCase()}/${provider?.lastName?.toLowerCase()}/${
        provider.npiId
      }`;
    }
    return `/providers/${provider?._id}`;
  };

  const goToProviderPage = (provider) => {
    const url = provider?.npiId
      ? `/${provider?.speciality?.toLowerCase()}/${provider?.lastName?.toLowerCase()}/${
          provider.npiId
        }`
      : `/providers/${provider?._id}`;
    navigate(url);
  };

  const goToPracticeLocationPage = (provider) => {
    navigate(
      `/${provider?.speciality?.toLowerCase()}/practice/${provider.npiId}/${
        provider?.practiceLocationGroupId
      }`
    );
  };

  const business =
    provider.userType === "wellness_provider" ||
    provider.userType === "massage_therapist"
      ? !isUndefined(provider.business_info)
        ? gymAddress(provider.business_info)
        : ""
      : "";

  return (
    <div className="col-md-12 mb-4">
      <div
        className="card h-100"
        style={{
          border: "solid 1px #F2F2F2",
          borderRadius: "8px",
        }}
      >
        <div
          className="card-body p-4"
          style={{
            border: "solid 1px #F2F2F2",
          }}
        >
          <div className="d-flex justify-content-center align-items-center flex-column flex-sm-row">
            <div className="d-flex justify-content-center align-items-center">
              <div className="me-3 mb-1">
                <Link
                  to={
                    provider?.npiId
                      ? `/${provider?.speciality?.toLowerCase()}/${provider?.lastName?.toLowerCase()}/${
                          provider?.npiId
                        }`
                      : `/providers/${provider?._id}`
                  }
                >
                  <Image
                    src={provider?.photo}
                    type="provider"
                    className="rounded-circle"
                    alt={`${provider?.firstName} ${provider?.lastName}`}
                    gender={provider?.gender?.toUpperCase()}
                    style={{
                      height: "calc(100px + 2vw)",
                      width: "calc(100px + 2vw)",
                      objectFit: "cover",
                      objectPosition: "top",
                    }}
                  />
                </Link>
              </div>
              <div>
                <h4 className="card-title fw-semibold profile-name">
                  <Link
                    to={
                      provider?.npiId
                        ? `/${provider?.speciality?.toLowerCase()}/${provider?.lastName?.toLowerCase()}/${
                            provider?.npiId
                          }`
                        : `/providers/${provider?._id}`
                    }
                    className="text-decoration-none text-black"
                  >
                    {provider?.userType === "hospital" ||
                    provider?.userType === "clinic" ||
                    provider?.userType === "gym" ||
                    provider?.userType === "rehabilitation_center"
                      ? provider?.firstName
                      : getProviderName(provider)}
                    {provider.mopRecommended && (
                      <i className="fa fa-check-circle text-info small ms-lg-2 ms-1 mt-2" />
                    )}
                  </Link>
                </h4>

                <span
                  className="d-flex flex-sm-row justify-content-between align-items-center mt-3 mobile-view-stack"
                  style={{
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <div className="d-flex align-items-center">
                    {" "}
                    <h6
                      className="card-subtitle mb-0 profile-title text-uppercase me-3 subtext-color"
                      style={{
                        fontWeight: "500",
                        ...(provider?.years_of_experience > 0 && {
                          borderRight: "solid 2px #EDEEF0",
                          paddingRight: "10px",
                        }),
                        marginBottom: "0",
                      }}
                    >
                      {provider?.userType === "wellness_provider"
                        ? provider?.title && provider?.title.length
                          ? `Wellness Provider - ${provider?.title}`
                          : "Wellness Provider"
                        : provider?.userType && provider?.userType.length
                        ? provider?.userType !== "neuro_surgeon"
                          ? provider?.userType?.split("_").join(" ")
                          : provider?.userType?.split("_").join("")
                        : ""}
                    </h6>
                    {provider?.years_of_experience > 0 && (
                      <div className="d-flex align-items-center">
                        <img
                          src={Briefcase}
                          alt="Experience"
                          height="16px"
                          className="me-2"
                          style={{ marginBottom: "0" }}
                        />
                        <h6
                          className="mb-0 subtext-color"
                          style={{
                            fontSize: "0.9rem",
                            fontWeight: "500",
                          }}
                        >
                          {provider.years_of_experience}{" "}
                          {provider.years_of_experience === 1
                            ? "year Experience"
                            : "years Experience"}
                        </h6>
                      </div>
                    )}
                  </div>
                </span>

                {provider?.isEnhancedProvider !== true &&
                  brand.key !== "mdp" && (
                    <a
                      href={`${brand.webUrl}/for-providers`}
                      className="text-decoration-none fs-18"
                    >
                      Claim Your Profile?
                    </a>
                  )}

                <p className="mt-2 card-text mb-1 d-flex align-items-center profile-address subtext-color">
                  {provider?.userType === "wellness_provider" ||
                  provider?.userType === "massage_therapist" ? (
                    business && business !== null && business !== "" ? (
                      <>
                        <span style={{ marginRight: "10px" }}>
                          <i className="fa fa-map-marker-alt"></i>
                        </span>
                        <span>{business}</span>
                      </>
                    ) : null
                  ) : (
                    <>
                      {/* {provider?.userType === "hospital" ||
                      provider?.userType === "gym" ||
                      provider?.userType === "clinic" ||
                      provider?.userType === "rehabilitation_center" ||
                      provider?.userType === "personal_trainer" ||
                      provider?.userType === "athletic_trainers"
                        ? gymAddress(provider) !== "" && (
                            <>
                              <span style={{ marginRight: "10px" }}>
                                <i className="fa fa-map-marker-alt"></i>
                              </span>
                              <span>{gymAddress(provider)}</span>
                            </>
                          )
                        : address !== "" && (
                            <>
                              <span style={{ marginRight: "10px" }}>
                                <i className="fa fa-map-marker-alt"></i>
                              </span>
                              <span>{address}</span>
                            </>
                          )} */}
                      {provider?.clinicAddress?.addressLine && (
                        <>
                          <p
                            className="card-text d-flex align-items-center subtext-color"
                            style={{ fontSize: "0.9rem" }}
                          >
                            <span style={{ marginRight: "10px" }}>
                              <img src={Location} height={"20px"} alt="" />
                            </span>
                            <span>
                              {provider.clinicAddress.addressLine}
                              <br />
                              {provider.clinicAddress.city},{" "}
                              {provider.clinicAddress.state}{" "}
                              {provider.clinicAddress.zipcode}
                            </span>
                          </p>
                        </>
                      )}
                    </>
                  )}
                </p>

                <div
                  className={`d-flex align-items-center mt-2 ${
                    provider?.googleReviewCount > 0 &&
                    provider?.npiId &&
                    provider?.isEnhancedProvider &&
                    provider?.googleRatting
                      ? ""
                      : "d-none"
                  }`}
                >
                  <div
                    className="d-flex align-items-center"
                    onClick={() =>
                      provider?.isPractice
                        ? goToPracticeLocationPage(provider)
                        : goToProviderPage(provider)
                    }
                  >
                    <i className="fab fa-google fa px-1"></i>&nbsp;
                    {[...Array(5)].map((_, index) => {
                      const rating = Number(provider?.googleRatting || 0);
                      const isFilled = index < Math.floor(rating);
                      const isHalf =
                        index === Math.floor(rating) && rating % 1 !== 0;

                      return (
                        <i
                          key={index}
                          className={`fas ${
                            isFilled
                              ? "fa-star"
                              : isHalf
                              ? "fa-star-half-alt"
                              : "fa-star"
                          } me-1`}
                          style={{
                            fontSize: "1.2rem",
                            color: isFilled || isHalf ? "#FFD700" : "#E5E5E5",
                          }}
                        ></i>
                      );
                    })}
                  </div>
                  <span
                    className="ms-2 profile-rating"
                    style={{
                      color: "#333",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                    }}
                  >
                    {provider?.googleReviewCount || 0}
                  </span>
                </div>
              </div>
            </div>

            <div className="d-flex flex-column justify-content-center align-items-center h-100 mobilebtn">
              <Link
                to={getProviderProfileUrl(provider)}
                className="button rounded-lg bg-transparent text-primary border border-primary mb-2 fw-bold text-decoration-none text-center"
                style={{
                  textDecoration: "none",
                  borderRadius: "4px",
                  padding: "10px 20px",
                }}
                state={{
                  userId: provider.userId,
                  evaluation: evaluation,
                  condition: condition,
                  id: provider?._id,
                }}
                onClick={() => {
                  sessionStorage.setItem("providerViewed", true);
                  window.fbq(
                    "track",
                    `${
                      provider?.firstName
                        ? provider?.firstName
                        : getProviderName(provider)
                    }'s Profile is viewed.`
                  );
                }}
              >
                View Profile
              </Link>
            </div>
          </div>
        </div>
      </div>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
      />
    </div>
  );
};
export default ProviderCard;
